export default __webpack_public_path__ + "static/twitter_icon-051fb0fa536d458791593595af2554b3.png";